import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { Input } from ".";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#fff",
  },
  container: {
    display: "grid",
    gridTemplateColumns: "200px auto  160px 160px 40px",
    alignItems: "center",
    columnGap: 16,
    padding: 4,
    minHeight: 40,
  },
  center: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },
  buttonContainer: {
    padding: 4,
  },
}));

export default function LoanPaymentItems({ remove, form, products = [] }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Typography variant="button">Product Code</Typography>
        <Typography variant="button">Description</Typography>
        <Typography variant="button" className={classes.center}>
          Loaned Qty
        </Typography>
        <Typography variant="button" className={classes.center}>
          Received Qty
        </Typography>
      </div>

      <Divider />

      {form.values?.items?.map((item, index) => (
        <React.Fragment key={index}>
          <div className={classes.container}>
            <Typography>{item.code}</Typography>

            <Typography>{item.description}</Typography>

            <div className={classes.center}>
              <Typography className={clsx(classes.moneyText, classes.money)}>
                {item?.loanedQuantity}
              </Typography>
            </div>

            <div className={classes.center}>
              <Input
                name={`items[${index}].quantity`}
                type="number"
                bottom={0}
              />
            </div>

            <IconButton
              color="inherit"
              edge="start"
              onClick={() => remove(index)}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </div>

          <Divider />
        </React.Fragment>
      ))}
    </div>
  );
}
